/* tslint:disable */
/* eslint-disable */
export enum UploadDocumentConflictType {
  UserVerificationNotFound = 'user_verification_not_found',
  DocumentAlreadyUploaded = 'document_already_uploaded'
}
